var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataTable',{attrs:{"title":'Borçlu Alıcı Listesi',"description":'',"dataList":_vm.top10CurrentBorrowerList,"dataHeaders":_vm.top10CurrentBorrowerListHeaders,"loading":_vm.top10CurrentBorrowerListLoading,"pagination-status":true,"pagination-length":_vm.maxPage},on:{"page-change":_vm.handlePageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }